import { ICaseLawDocument } from "../../../caseLawDocuments/model/CaseLawDocument";
import CaseLawDocumentMapper from "../../../caseLawDocuments/service/CaseLawDocumentMapper";
import CaseLawDocumentParamMapper from "../../../caseLawDocuments/service/CaseLawDocumentParamMapper";
import GetAllResourceEntriesInteractor from "../../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../../common/Constants";

export default class GetInvalidatedCaseLawDocumentsInteractor {
  private resource: GetAllResourceEntriesInteractor<ICaseLawDocument>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(caseLawDocumentId: number) {
    return this.resource.execute(
      `${Constants.caseLawDocumentPath}/${caseLawDocumentId}/invalidated`,
      CaseLawDocumentMapper,
      CaseLawDocumentParamMapper
    );
  }
}
